module.exports = __webpack_public_path__ + "static/media/academy-mobile.337ed42b.png";